import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fuses',
  templateUrl: './fuses.component.html',
  styleUrls: []
})
export class FusesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
